module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/chapel_sns_06-53c7dfa5d7f423e6db932f53bd05a9f3.jpg";